import React, { Suspense } from 'react';
import type { EditorProps } from '@monaco-editor/react';
import { Spinner } from './ui';

// The Monaco editor, loaded on first use (its chunk is large: the dashboards and the login page don't need it).
const MonacoEditor = React.lazy(() => import('./MonacoEditor'));

const CodeEditor: React.FC<EditorProps> = (props) => (
  <Suspense fallback={<div className="flex h-full items-center justify-center"><Spinner className="w-5 h-5 text-gray-400" /></div>}>
    <MonacoEditor {...props} />
  </Suspense>
);

export default CodeEditor;
